import React from 'react';

function Footer() {
  return (
    <footer className="bg-gray-900 text-white text-center py-6">
      <p className="text-lg mb-2">&copy; 2024 CrossTax Advisors. All rights reserved.</p>
      <p className="text-sm mb-4">Your trusted partner in tax advisory services for accounting firms of all sizes.</p>
      <div className="flex justify-center space-x-4">
        <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="footer-link text-white hover:text-accent">
          <i className="fab fa-linkedin fa-lg"></i>
        </a>
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="footer-link text-white hover:text-accent">
          <i className="fab fa-twitter fa-lg"></i>
        </a>
      </div>
    </footer>
  );
}

export default Footer;
